/* eslint-disable max-len */
/* Source: loyaltyperks12@yopmail.com in PROD */
/* As of 2024Q2: VIP user with Gold Paint, Unclaimed perks, Available perks, Available Offers, and zero Challenges */
import { getFormattedDaysFromToday } from '../../common/utils/DrawerUtils';

export default {
  customerAccountId: '04261DFAD0A3DFA10S',
  currentTierId: '35c8d2a6-28ff-40c4-b34e-b950f7ef4e66',
  currentYearSpend: 65,
  perkCounter: 0,
  recentlyAdded: false,
  programMembershipStartDate: '05/18/2023',
  activePxccFactor: 4,
  pxccUserCategory: 'Enrolled',
  accrualData: [
    {
      year: 2024,
      currentYear: true,
      accrual: 65,
      acceleratedAccrual: 65,
      pxccAccrual: 0,
      pxccAcceleratedAccrual: 0,
      nonPxccAccrual: 65,
      spendForNextPerk: 599935,
      spendForNextPerkWithPxcc: 149984,
      spendForFutureTierPerk: 699935,
      spendForFutureTierPerkWithPxcc: 174984,
      finalTierPerkAchieved: false
    }
  ],
  nonProgramPerks: [
    {
      perkId: '83ce6721-00e3-47fc-b05d-eedcbc41a1a3',
      perkTitle: '$1 off of $15 - TEST',
      perkDescription: '$1 off of $15 - TEST',
      perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_$1%20off%20of%20$15%20-%20TEST_993eae4b-7206-4c85-a96d-83810d91ca22',
      shortDescription: '$1 off of $15',
      shortName: '$1 off of $15',
      perkStatus: 'ACTIVE',
      perkType: 'THD_COUPONS_CMS',
      activationType: 'CMS',
      triggerType: 'MANUAL_ADMIN_ISSUED',
      offerType: 'OFFER',
      availability: 'IN_STORE',
      creationTime: '05/20/2024',
      activationTime: '05/20/2024',
      expirationTime: getFormattedDaysFromToday(90),
      yearEarned: 2024,
      daysLeft: 331,
      perkSourceUUID: '31916ce1-a55a-47f8-8b0e-acf484e4ad2b',
      paymentId: 'P1353A415D540EAE20',
      perkDisplaySeqNumber: 1,
      amount: 1,
      availableBalance: 0,
      options: [],
      renewed: false,
      exchanged: false,
      adminIssued: true,
      bulkIssued: false,
      bonusPerk: true,
      giftCard: false,
      rewardId: '012c565e-b9d4-4be6-923b-9f626eafa963'
    },
    { // used in example offer Reward Barcode Drawer in local instance
      perkId: 'eaa40358-14d6-4ba0-82e5-01179c7a6857',
      perkTitle: 'Pro Xtra Dollars',
      perkDescription: '**Important details about your Pro Xtra Dollars:**\n* Pro Xtra Dollars are Home Depot Digital Reward Cards.\n* Expires 12 months after selection.\n* May be used to purchase merchandise/services at Home Depot stores in U.S. and Canada and online at HomeDepot.com.\n* Can be redeemed in-store or online during checkout.\n* Not redeemable for cash or credit unless required by law.\n* See [Pro Xtra Terms and Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for additional details.',
      perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-PXDollars_653ca682-5b46-4b2d-8b19-24d397a363de.png',
      shortName: 'Pro Xtra Dollars',
      perkStatus: 'ACTIVE',
      perkType: 'GIFT_CARD',
      activationType: 'PAYMENTS',
      triggerType: 'MANUAL_ADMIN_ISSUED',
      offerType: 'OFFER',
      availability: 'OMNI_CHANNEL',
      creationTime: '05/20/2024',
      activationTime: '05/20/2024',
      expirationTime: getFormattedDaysFromToday(90),
      yearEarned: 2024,
      daysLeft: 331,
      perkSourceUUID: 'a6680de2-1146-4cc0-a3d8-e9b5e14e8c2b',
      paymentId: 'P1353A4179117E9880',
      perkDisplaySeqNumber: 2,
      amount: 1,
      availableBalance: 1,
      options: [],
      renewed: false,
      exchanged: false,
      adminIssued: true,
      bulkIssued: false,
      bonusPerk: false,
      giftCard: true,
      rewardId: '1e18a0df-dbc8-4cfe-93f2-84c046a003fd'
    },
    {
      perkId: 'fb9086e0-a937-4a8a-8e54-468e44eb278e',
      perkTitle: 'Pro Xtra Dollars - HD Pass',
      perkDescription: '**Important details about your reward:**\n* Your Virtual ID will update to the HD Pass after 24 hours.\n* You will receive $25 Pro Xtra Dollars 24 hours after joining the test.\n* You will receive an additional $75 Pro Xtra Sollars 24 hours after scanning twice and completing the survey.\n* For more details, visit [https://www.homedepot.com/c/hd-pass](https://www.homedepot.com/c/hd-pass)\n* Pro Xtra Dollars are Home Depot Digital Reward Cards.\n* Expires after 12 months.\n* May be used to purchase merchandise/services at Home Depot stores in U.S. and Canada and online at HomeDepot.com.\n* Can be redeemed in-store or online during checkout.\n* Not redeemable for cash or credit unless required by law.\n* See [Pro Xtra Terms and Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for additional details.',
      perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Pro%20Xtra%20Dollars%20-%20HD%20Pass_e2a0ff61-22cf-4671-8a02-4ecc264a9e2a',
      shortDescription: '',
      shortName: '',
      perkStatus: 'ACTIVE',
      perkType: 'GIFT_CARD',
      activationType: 'PAYMENTS',
      triggerType: 'CAMPAIGN_ISSUED',
      offerType: 'OFFER',
      availability: 'OMNI_CHANNEL',
      creationTime: '05/21/2024',
      activationTime: '05/20/2024',
      expirationTime: getFormattedDaysFromToday(90),
      yearEarned: 2024,
      daysLeft: 320,
      perkSourceUUID: '8ed2cf9b-0253-4f34-97d4-5db0a529e5a5',
      paymentId: 'P1353A621AD97A1E20',
      perkDisplaySeqNumber: 3,
      amount: 25,
      availableBalance: 25,
      options: [],
      renewed: false,
      exchanged: false,
      adminIssued: false,
      bulkIssued: false,
      bonusPerk: false,
      giftCard: true,
      rewardId: 'f46fc2e7-edb5-4b01-8d7f-043ad447b96d'
    }
  ],
  previousYearPerks: []
};
